// Helpers for consistent Plot IDs across old/new shapes

export type PlotLike = { id?: string | number; identity?: { plotId?: string | number } } | null | undefined;

export const getPlotId = (p: PlotLike): string => {
  const pid = (p as any)?.identity?.plotId ?? (p as any)?.id ?? "";
  return typeof pid === "string" ? pid : pid != null ? String(pid) : "";
};